<template>
        <div class="font-16px col-lg-6">
            <i class="tio-add-circle color-yellow"></i> Aggiungi eventuale altra documentazione
        </div>
</template>

<script>
export default {
    name: "Documentation"
}
</script>

<style scoped>
.color-yellow {
    color: #F2B12D;
}
</style>
